/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Response containing a time-limited signed URL to access the visit form.
 * @export
 * @interface GenerateFormLinkResponse
 */
export interface GenerateFormLinkResponse {
    /**
     * Form link with time-limited JWT Token to access the visit form
     * @type {string}
     * @memberof GenerateFormLinkResponse
     */
    formLink: string;
}

/**
 * Check if a given object implements the GenerateFormLinkResponse interface.
 */
export function instanceOfGenerateFormLinkResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "formLink" in value;

    return isInstance;
}

export function GenerateFormLinkResponseFromJSON(json: any): GenerateFormLinkResponse {
    return GenerateFormLinkResponseFromJSONTyped(json, false);
}

export function GenerateFormLinkResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateFormLinkResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'formLink': json['form_link'],
    };
}

export function GenerateFormLinkResponseToJSON(value?: GenerateFormLinkResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'form_link': value.formLink,
    };
}

